/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    initialQueryState,
    PaginationState,    
    stringifyRequestQuery,
    WithChildren,
} from '../../../../_metronic/helpers'

import { getApplications, getAllApplications } from './_requests'
import { ApplicationsListItem } from './_models'
import { useApplicationQueryRequest } from './ApplicationQueryRequestProvider'
import { useAuth } from '../../auth'

const ApplicationQueryResponseContext = createResponseContext<ApplicationsListItem>(initialQueryResponse)
const ApplicationQueryResponseProvider: FC<WithChildren> = ({children}) => {
    const {state} = useApplicationQueryRequest()
    const {currentUser} = useAuth();

    const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
    const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

    const { listmode } = state;
    
    useEffect(() => {        
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        ['APPLICATIONS-LIST', listmode],
        // @ts-ignore
        () => {               
            if (currentUser && currentUser.role === 'System Admin') {
                // dummy response for 'System Admin' only accounts
                return Promise.resolve().then(() => {
                    return {data : [] , payload : {}};
                })
            } else if (listmode === 'all') {
                return getAllApplications();
            } else { 
                return getApplications();
            }            
        },
        {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
    )

    return (
    <ApplicationQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
        {children}
    </ApplicationQueryResponseContext.Provider>
    )
}

const useApplicationQueryResponse = () => useContext(ApplicationQueryResponseContext)

const useApplicationQueryResponseData = () => {
    const {response} = useApplicationQueryResponse()
    if (!response) {
        return []
    }

    return response?.data || []
}

const useApplicationQueryResponsePagination = () => {
    const defaultPaginationState: PaginationState = {
        links: [],
        ...initialQueryState,
    }

  const {response} = useApplicationQueryResponse()
    if (!response || !response.payload || !response.payload.pagination) {
        return defaultPaginationState
    }

    return response.payload.pagination
}

const useApplicationQueryResponseLoading = (): boolean => {
  const {isLoading} = useApplicationQueryResponse()
  return isLoading
}

export {
    ApplicationQueryResponseProvider,
    useApplicationQueryResponse,
    useApplicationQueryResponseData,
    useApplicationQueryResponsePagination,
    useApplicationQueryResponseLoading,
}
